import React from "react";

import { ComputeResourcesTable, NetworkDetailsTable } from "./DeviceDetails";
import { SetupSection } from "./SetupSection";
import type { AddedComputeNode, ComputeNodeNetworkMode } from "./types";

const DeviceConnected: React.FC<{
  node: AddedComputeNode;
  sshAccess: Array<{ userId: string; linuxUser: string }>;
  isSSHEnabled: boolean;
  usesCertAuthSSHProvider: boolean;
  onCheckSSHAccess: () => Promise<void>;
  onGrantUser: (userId: string, linuxUser: string) => Promise<void>;
  onRevokeUser: (userId: string, linuxUser: string) => Promise<void>;
  networkMode: ComputeNodeNetworkMode;
  onNetworkModeChange: (mode: ComputeNodeNetworkMode) => Promise<void>;
}> = ({
  node,
  sshAccess,
  isSSHEnabled,
  usesCertAuthSSHProvider,
  onCheckSSHAccess,
  onGrantUser,
  onRevokeUser,
  networkMode,
  onNetworkModeChange,
}) => (
  <div className="animate-slide-up-380">
    <div className="grid grid-cols-[minmax(220px,280px)_1px_minmax(520px,1fr)] items-start gap-8 max-[1024px]:grid-cols-1 max-[1024px]:gap-[28px]">
      <div className="col-start-1 min-w-0 max-[1024px]:col-start-1 max-[1024px]:grid max-[1024px]:grid-cols-[repeat(2,minmax(0,1fr))] max-[1024px]:gap-6 max-[640px]:grid-cols-1">
        <ComputeResourcesTable node={node} />
        <NetworkDetailsTable node={node} />
      </div>
      <div
        className="col-start-2 h-full min-h-[480px] w-px bg-zinc-900 max-[1024px]:hidden"
        aria-hidden="true"
      />
      <div className="col-start-3 min-w-0 max-[1024px]:col-start-1">
        <SetupSection
          sshAccess={sshAccess}
          isSSHEnabled={isSSHEnabled}
          usesCertAuthSSHProvider={usesCertAuthSSHProvider}
          onCheckSSHAccess={onCheckSSHAccess}
          onGrantUser={onGrantUser}
          onRevokeUser={onRevokeUser}
          networkMode={networkMode}
          onNetworkModeChange={onNetworkModeChange}
        />
      </div>
    </div>
  </div>
);

export default DeviceConnected;
